<template>
  <div class="footer">
    <field-popup :confirmField="nextAction" />
    <div class="footer__core">
      <div class="footer__help-buttons">
        <app-button :text="$t('footer.isThisLegal')" :action="isThisLegal"></app-button>
        <app-button :text="$t('footer.iHaveAQuestion')" :action="question" v-if="$store.getters.canShowQuestions"></app-button>
      </div>
      <div class="footer__core__right">
        <app-button
          v-if="currentField.type === 'signature' || currentField.type == 'upload' || currentField.type === 'date'"
          :text="$t('functional.confirm')"
          iconName="check"
          :action="nextAction"
          data-cy="confirmField"
          classList="button--cta float-right"></app-button>
        <app-button
          v-else
          :text="nextButtonText"
          :action="nextAction"
          data-cy="field-next"
          classList="button--cta float-right"></app-button>
        <div class="footer__info float-right">{{ itemsToCompleteText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton'
import FieldPopup from '@/components/FieldPopup'
import { mapGetters } from 'vuex'
import { submitEnvelope } from '@/store/api'

export default {
  name: 'document-footer',
  components: {
    AppButton,
    FieldPopup
  },
  computed: {
    ...mapGetters([
      'outstandingFieldsNo',
      'activeFieldId',
      'isEnvelopeComplete',
      'nextField'
    ]),
    currentField () {
      return this.$store.getters.getField(this.activeFieldId, false)
    },
    itemsToCompleteText () {
      if (this.outstandingFieldsNo === 0) {
        return this.$t('footer.allComplete')
      } else if (this.outstandingFieldsNo === 1) {
        return this.$t('footer.oneToComplete')
      }

      return this.$t('footer.pluralToComplete', { count: this.outstandingFieldsNo })
    },
    nextButtonText () {
      const isDocumentDone = this.$store.getters.isDocumentDone()

      if (this.isEnvelopeComplete && this.$store.getters.activeFieldId) {
        return this.$t('functional.confirm')
      } else if (this.isEnvelopeComplete) {
        return this.$store.getters.config('company_consumer_regulations') === '1' ? this.$t('footer.order') : this.$t('footer.submit')
      } else if (isDocumentDone) {
        return this.$t('footer.nextDocument')
      } else if (this.nextField) {
        const hasTitle = this.nextField.title !== 'Untitled'
        const buttonText = hasTitle ? this.nextField.title : this.$t(`fieldPopup.type.${this.nextField.type}`)
        return this.$t('footer.nextField', { field: buttonText })
      }

      return ''
    }
  },
  methods: {
    isThisLegal () {
      this.$bus.$emit('openModal', 'helpModal')
      this.$bus.$emit('selectTab', 'is-this-legal')
    },
    question () {
      this.$bus.$emit('openModal', 'helpModal')
      this.$bus.$emit('selectTab', 'contact-signable-team')
    },
    nextAction (e) { // Stop deleting uploaded files being treated as having been completed.
      if (this.currentField.type === 'textarea' && e.keyCode && e.keyCode === 13) return
      if (this.currentField.type === 'signature') this.$bus.$emit('confirmSignatureField', this.activeFieldId)

      const isDocumentDone = this.$store.getters.isDocumentDone()

      if (this.isEnvelopeComplete && this.activeFieldId) {
        this.$store.commit('setActiveField', { activeFieldId: null })
      } else if (this.isEnvelopeComplete) {
        if (window.IS_PREVIEW) {
          alert(this.$t('footer.signPreviewWarning'))
        } else if (this.$store.getters.isWidget) {
          this.$bus.$emit('openModal', 'widgetPartyInfoModal')
        } else {
          this.$bus.$emit('loading')

          submitEnvelope({ store: this.$store }).then((response) => {
            this.$bus.$emit('submitEnvelope', { response })
          })
        }
      } else if (isDocumentDone) {
        this.$store.commit('setActiveField', { activeFieldId: null })
        this.$store.dispatch('nextDocument')
        this.$bus.$emit('nextDocument')
      } else {
        this.$store.commit('setActiveField', { activeFieldId: this.nextField.id })
        this.$bus.$emit('scrollBody')
        if (this.nextField.type === 'checkbox') {
          this.$bus.$emit('highlightField', { field: this.nextField })
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .footer
    background-color: #fff
    position: fixed
    bottom: 0
    right: 0
    width: 75%
    box-shadow: 0px -15px 15px -20px $color-grey
    @include clearfix
    a
      margin-left: $spacing-base
      &:first-child
        margin-left: 0
      &.float-right
        margin-left: 0
    &__core
      padding: $spacing-base
      min-height: 75px
      &__right
        a.button
          margin-left: $spacing-base
    &__info
      padding: $spacing-small + 2
      padding-right: 0
      color: $color-main-dark
      font-weight: bold
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .footer
      width: 100%
      &__help-buttons
        display: none
</style>
